import React, { useEffect, useState } from "react";
import { hourFormat } from "functions/functions";
import "./cardItemEventoCalendarioParalimpicos.sass";

export default function CardItemEventoCalendarioParalimpicos({ sportCode, arrayMostrar, item, id, index }) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 780);
    const [flagMobile, setFlagMobile] = useState(isMobile);
    const [vermas, setvermas] = useState(false);

    const updateMobileStatus = () => {
        setIsMobile(window.innerWidth <= 780);
        setFlagMobile(window.innerWidth <= 780);
    };

    useEffect(() => {
        window.addEventListener('resize', updateMobileStatus);

        return () => {
            window.removeEventListener('resize', updateMobileStatus);
        };
    }, []);


    // Define el estilo del contenedor de participantes
    const containerStyle = {
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(250px, 1fr))`,
    };

    const clickVerMas = () => {
        setvermas(!vermas);
    }

    const hasTeam = item.teams && item.teams.length > 0 ? item.teams : item.participants;

    return (
        <div key={id + "-" + index} id="card-evento-lista-paralimpicos" className={`card-evento-lista-participantes ${arrayMostrar.includes(id) ? 'visibleCard' : ''}`}>

            <div className="card-evento-dia-horario">
                <div className="card-evento-horario">
                    <p>{hourFormat(item.startDate)}</p>
                    <p className="separador-horario">-</p>
                    <p>{hourFormat(item.endDate)}</p>
                </div>
            </div>

            {String(sportCode) === "CER"
                ? <div className="card-evento-ceremonia"> <h3>{(String(item.eventNameEs).length > 0 ? item.eventNameEs : item.eventName)}</h3></div>
                : <div className="contenedor-listado-ul" >
                    <div className="titulo-listado-ul"> <h3 className="">{(String(item.eventNameEs).length > 0 ? item.eventNameEs : item.eventName)}</h3></div>
                    {hasTeam && hasTeam.length > 0 &&
                        <ul className="card-evento-participantes" style={containerStyle}>

                            {hasTeam.map((participante, id) => (
                                flagMobile && hasTeam.length >= 4 && id <= 2 && !vermas
                                    ? <li key={String(participante.name).replace(/ /g, "") + "-" + id}>
                                        <div className="div-contenedor-participantes">
                                            <div className="div-bandera-pais">
                                                <div
                                                    className={"bandera-" + participante.oganisation}
                                                ></div>
                                            </div>

                                            <p> {participante.name} {participante.lastName}</p>
                                        </div>
                                    </li>
                                    : flagMobile //&& hasTeam.length >= 4 && vermas
                                        ? <li key={String(participante.name).replace(/ /g, "") + "-" + id}>
                                            <div className="div-contenedor-participantes">
                                                <div className="div-bandera-pais">
                                                    <div
                                                        className={"bandera-" + participante.organisation}
                                                    ></div>
                                                </div>

                                                <p>{participante.name} {participante.lastName}</p>
                                            </div>
                                        </li>
                                        : !flagMobile && <li key={String(participante.name).replace(/ /g, "") + "-" + id}>
                                            <div className="div-contenedor-participantes">
                                                <div className="div-bandera-pais">
                                                    <div
                                                        className={"bandera-" + participante.organisation}
                                                    ></div>
                                                </div>

                                                <p>{participante.name} {participante.lastName}</p>
                                            </div>
                                        </li>
                            ))}
                        </ul>
                    }

                    {flagMobile && hasTeam && hasTeam.length !== 0 && hasTeam.length > 3 &&
                        <div className="container-btn">
                            <button onClick={clickVerMas} className={vermas ? "vermenos" : "vermas"}>{!vermas ? "Ver más" : "Ver menos"}</button>
                        </div>
                    }
                </div>
            }
        </div>
    )
}